import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import TuneIcon from "@mui/icons-material/Tune";

// SearchUI components
import { ResultsPerPage, Sorting } from "@elastic/react-search-ui";
import SORT_OPTIONS from "../searchui/SortOptions";
import { MuiSortingViewInline } from "./facets/MuiSortingView";
import { TOOLBAR_STRIP_HEIGHT } from "../styles/layoutSizes";

const ToolbarRow = styled("div")(({ theme }) => ({
  position: "sticky",
  top: 0,
  zIndex: 4,
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  paddingInline: theme.spacing(1.25),
  paddingBlock: 0,
  height: TOOLBAR_STRIP_HEIGHT,
  backgroundColor: theme.palette.background.paper,
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

const Spacer = styled("div")({ flex: 1 });

const InlineLabel = styled(Typography)(({ theme }) => ({
  fontSize: "0.75rem",
  color: theme.palette.text.secondary,
  fontWeight: 500,
}));

const muiResultsPerPageView = ({ onChange, options = [], value }) => (
  <div style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
    <InlineLabel component="span">Show:</InlineLabel>
    <TextField
      select
      size="small"
      value={value || ""}
      onChange={(e) => onChange(Number(e.target.value))}
      sx={{
        minWidth: 64,
        "& .MuiInputBase-input": { py: 0.375, fontSize: "0.8125rem" },
      }}
    >
      {options.map((opt) => (
        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
      ))}
    </TextField>
  </div>
);

function SearchBodyHeader({ onOpenFilters }) {
  return (
    <ToolbarRow>
      <IconButton
        size="small"
        onClick={onOpenFilters}
        aria-label="open filters"
        sx={{ display: { xs: "inline-flex", md: "none" } }}
      >
        <TuneIcon fontSize="small" />
      </IconButton>
      <Sorting label="Sort" sortOptions={SORT_OPTIONS} view={MuiSortingViewInline} />
      <Spacer />
      <ResultsPerPage options={[10, 25, 50]} view={muiResultsPerPageView} />
    </ToolbarRow>
  );
}

export default SearchBodyHeader;

SearchBodyHeader.propTypes = {
  onOpenFilters: PropTypes.func,
};
